import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'Root';
import 'typeface-roboto'; // eslint-disable-line import/extensions
import 'normalize.css';
ReactDOM.render(<Root />, document.getElementById('react'));
